import { all, takeLatest } from 'redux-saga/effects';

import { ACTION_GET_VEHICLE_ONGOING_TRIP_PIN_CODE } from '../../redux/fuelCard/types';

import { getVehicleOngoingTripPINCodeSaga } from './get';

export default function*() {
    yield all([takeLatest(ACTION_GET_VEHICLE_ONGOING_TRIP_PIN_CODE, getVehicleOngoingTripPINCodeSaga)]);
}
